<div class="container audience-container">
  <div class="container-content">
    <div class="container-row">
      <ng-container *ngIf="!fromCustomer">
        {{ isNewAudience ? "Create new" : "Edit" }} audience
      </ng-container>
      <ng-container *ngIf="fromCustomer"> Refine Customer List </ng-container>
    </div>
    <div *ngIf="hasQsWrite" class="container-row audience-name-row">
      <lhpe-input
        class="input"
        controlName="audienceName"
        [placeholder]="
          fromCustomer
            ? 'List name (leave blank if you don’t wish to save)'
            : 'Audience name'
        "
        [formGroup]="audienceForm!"
        [required]="!fromCustomer"
      >
      </lhpe-input>
      <div *ngIf="audienceCount || audienceCount === 0" class="audience-size">
        Current audience size: <span class="number">{{ audienceCount }}</span>
      </div>
    </div>

    <div *ngIf="!fromCustomer&&hasQsWrite" class="container-row audience-name-row">
      <lhpe-input
        class="input"
        controlName="keyword"
        [placeholder]="'Keyword'"
        [formGroup]="audienceForm!"
      >
      </lhpe-input>
    </div>

    <div class="traits">
      <div class="status-traits">
        <div class="container-row">Status traits</div>
        <div class="container-row">
          <lhpe-select
            controlName="registrationStatus"
            placeholder="Registration status"
            [formGroup]="audienceForm!"
            [options]="uiService.registrationStatusOptions"
          >
          </lhpe-select>
        </div>
        <div class="container-row">
          <lhpe-select
            controlName="physicalPresence"
            placeholder="Physical presence"
            [formGroup]="audienceForm!"
            [options]="uiService.physicalPresenceOptions"
          >
          </lhpe-select>
        </div>
        <div class="container-row">
          <lhpe-select
            controlName="locationPermission"
            placeholder="Location permission"
            [formGroup]="audienceForm!"
            [options]="uiService.locationPermissionOptions"
          >
          </lhpe-select>
        </div>
        <div class="container-row">
          <lhpe-select
            controlName="notificationPermission"
            placeholder="Notification permission"
            [formGroup]="audienceForm!"
            [options]="uiService.notificationPermissionOptions"
          >
          </lhpe-select>
        </div>
        <div class="container-row">
          <lhpe-select
            controlName="bluetoothPermission"
            placeholder="Bluetooth permission"
            [formGroup]="audienceForm!"
            [options]="uiService.blutetoothPermissionOptions"
          >
          </lhpe-select>
        </div>
        <div *ngIf="hasBrList && hasGfList" class="container-row">
          <lhpe-select
            controlName="currentLocations"
            placeholder="Current location(s)"
            [formGroup]="audienceForm!"
            [options]="locationOptions"
            [multiple]="true"
            [optionIsSelf]="true"
            displayValue="name"
          >
          </lhpe-select>
        </div>

        <div class="container-row">
          <lhpe-option-snack-group>
            <lhpe-option-snack
              *ngFor="
                let currentLocation of audienceForm.controls.currentLocations
                  .value
              "
              [option]="currentLocation"
              name="{{ currentLocation.name }}"
              (optionRemoved)="removeLocation($event)"
            >
            </lhpe-option-snack>
          </lhpe-option-snack-group>
        </div>
      </div>
      <div class="behavioral-traits">
        
        <div class="container-row">Behavioral traits</div>

        <div class="container-row">
          <lhpe-select
            controlName="addTrait"
            placeholder="Add trait"
            [formGroup]="audienceForm!"
            [options]="traits()"
            [optionIsSelf]="true"
            displayValue="name"
          >
          </lhpe-select>
        </div>

        <div class="behavioral-containers">
          <div
            *ngFor="let behavior of (selectedBehaviorTraits || [])"
            class="behavioral-container"
          >
            <div class="container-row name">{{traitForms[behavior.id]!.controls.name.value}}</div>

            <div class="container-row">
              <lhpe-select
                controlName="conditional"
                placeholder="Conditional"
                [formGroup]="traitForms[behavior.id]!"
                [options]="conditionsForTrait(behavior)"
                displayValue="name"
                [required]="true"
              >
              </lhpe-select>
            </div>

            <div class="container-row">

              <!-- Date -->
              <ng-container *ngIf="behavior.type === 'Date'">
                <div class="icon">
                  <button
                    mat-button
                    class="icon-btn"
                    (click)="datePicker.openPicker()"
                  >
                    <svg-icon
                      src="assets/svg/calendar.svg"
                      [svgStyle]="{
                        'width.px': '26.5',
                        'height.px': '26.5'
                      }"
                      svgClass="grey"
                    >
                    </svg-icon>
                  </button>
                </div>
                <lhpe-datepicker
                  class="date-picker"
                  #datePicker
                  [hideToggle]="true"
                  placeholder="mm/dd/yyyy"
                  [formGroup]="traitForms[behavior.id]!"
                  controlName="answer"
                  [required]="true"
                >
                </lhpe-datepicker>
              </ng-container>

              <!-- String, Number, Float, Integer WITHOUT options -->
              <ng-container
                *ngIf="
                  (behavior.type === 'String' ||
                    behavior.type === 'Number' ||
                    behavior.type === 'Float' ||
                    behavior.type === 'Integer') &&
                  behavior.options.length === 0
                "
              >
                <lhpe-input
                  controlName="answer"
                  [formGroup]="traitForms[behavior.id]!"
                  placeholder="Answer"
                  [ignoreDisabledStyling]="true"
                  [required]="true"
                  [type]="
                    behavior.type === 'Number' || behavior.type === 'Integer'
                      ? 'number'
                      : 'text'
                  "
                >
                </lhpe-input>
              </ng-container>

              <!-- Boolean, String, Number, Integer, Float WITH options -->
              <ng-container
                *ngIf="
                  (behavior.type === 'String' ||
                    behavior.type === 'Number' ||
                    behavior.type === 'Integer' ||
                    behavior.type === 'Float' ||
                    behavior.type === 'Boolean'
                  ) &&
                  behavior.options.length > 0
                "
              >
                <lhpe-select
                  controlName="answer"
                  [formGroup]="traitForms[behavior.id]!"
                  placeholder="Answer"
                  [required]="true"
                  [options]="behavior.options"
                  displayValue="label"
                  optionValue="value"
                >
                </lhpe-select>
              </ng-container>

              <!-- Array, String[], Number[], Integer[], Float[] WITHOUT OPTIONS -->
              <ng-container
                *ngIf="
                  (
                  behavior.type === 'Array' || 
                  behavior.type === 'String[]' || 
                  behavior.type === 'Number[]' || 
                  behavior.type === 'Integer[]' || 
                  behavior.type === 'Float[]'
                  ) && behavior.options.length === 0
                "
              >
                <div class="info">Separate values with commas</div>
                <lhpe-input
                  controlName="answer"
                  [formGroup]="traitForms[behavior.id]!"
                  placeholder="Answer"
                  [required]="true"
                >
                </lhpe-input>
              </ng-container>

              <!-- Array, String[], Number[], Integer[], Float[] WITH OPTIONS -->
              <ng-container
                *ngIf="
                  (
                  behavior.type === 'Array' || 
                  behavior.type === 'String[]' || 
                  behavior.type === 'Number[]' || 
                  behavior.type === 'Integer[]' || 
                  behavior.type === 'Float[]'
                  ) && behavior.options.length > 0
                "
              >
              <lhpe-select
                controlName="answer"
                placeholder="Select"
                [formGroup]="traitForms[behavior.id]!"
                [options]="behavior.options"
                [multiple]="true"
                [optionIsSelf]="true"
                displayValue="label"
              >
              </lhpe-select>
              </ng-container>

            </div>

            <div class="container-row button-row">
              <button mat-icon-button class="delete-btn">
                <svg-icon
                  src="assets/svg/trashcan.svg"
                  [svgStyle]="{
                    'width.px': '22.5',
                    'height.px': '22.298'
                  }"
                  svgClass="lightGreyIcon"
                  (click)="removeBehaviorTrait(behavior)"
                ></svg-icon>
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
